import { buildNonMonetaryDetailSheet, PUNISHMENT_WIDTHS, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Punishment";

export function buildPunishmentSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildNonMonetaryDetailSheet(
    workbook,
    SHEET_NAME,
    "Punishment",
    toRows(essential?.nonMonetary?.punishment),
    { widths: PUNISHMENT_WIDTHS, headerHeight: 19.9 }
  );
}
